export default function Recruit() {
  return (
    <div className='wrapper'>
      <iframe
        src='https://recruit-sigmatech.oopy.io'
        title='recruit'
        className='w-full min-h-[calc(100vh-60px)]'
      />
    </div>
  )
}
